"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordPage = void 0;
const react_1 = __importStar(require("react"));
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const doshx_controls_web_1 = require("doshx_controls_web");
const PasswordInputControl_1 = require("../../../controls/PasswordInputControl");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const constants_1 = require("../../../constants/constants");
const routes_1 = require("../../../constants/routes");
const validateForm_1 = require("../../../helpers/validateForm/validateForm");
const main_1 = require("../../../reducers/slices/main");
const user_1 = require("../../../reducers/slices/user/user");
const update_password_1 = require("../../../api/calls/user/update_password");
const local_storage_names_1 = require("../../../constants/local_storage_names");
const initialResetPasswordValues = { password: "", confirmPassword: "" };
// Password strength pattern — matches backend Joi validation (schemas/auth.ts)
const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#()^])[A-Za-z\d@$!%*?&#()^]{8,}$/;
const PASSWORD_REQUIREMENTS = "Must contain at least 8 characters, one uppercase letter, one lowercase letter, one number, and one special character (@$!%*?&#()^)";
const ENFORCE_PASSWORD_STRENGTH = process.env.ENFORCE_PASSWORD_STRENGTH === "true";
const ResetPasswordPage = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { forgot_password_id } = (0, react_router_dom_1.useParams)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const { user, token, isLoading } = (0, react_redux_1.useSelector)((state) => state.userState);
    const [credentials, setCredentials] = (0, react_1.useState)(initialResetPasswordValues);
    const validationConfig = { password: { required: true }, confirmPassword: { isEqualTo: { key: "password", value: credentials.password } } };
    const formValidation = (0, validateForm_1.validateForm)(credentials, { validationConfig });
    // Password strength check — controlled by ENFORCE_PASSWORD_STRENGTH flag
    const passwordStrengthError = ENFORCE_PASSWORD_STRENGTH && credentials.password.length > 0 && !PASSWORD_PATTERN.test(credentials.password) ? PASSWORD_REQUIREMENTS : undefined;
    const errors = Object.assign(Object.assign({}, formValidation.errors), (passwordStrengthError ? { password: passwordStrengthError } : {}));
    const isValid = formValidation.isValid && !passwordStrengthError;
    (0, react_1.useEffect)(() => {
        if ((user === null || user === void 0 ? void 0 : user._id) && token) {
            navigate(routes_1.CONSOLE_ROUTE);
        }
    }, [user]);
    const showLoader = () => {
        dispatch((0, main_1.setContentModal)({
            title: "Please Wait...",
            content: react_1.default.createElement(doshx_controls_web_1.CircularLoaderControl, { size: "small" }),
        }));
    };
    const handleResponse = (response) => {
        if (response.success) {
            setCredentials(initialResetPasswordValues);
            localStorage.setItem(local_storage_names_1.USER_LOCAL_STORAGE, JSON.stringify(response.content));
            dispatch((0, user_1.setUserToken)(response.content.token));
            dispatch((0, user_1.setUser)(response.content.user));
            dispatch((0, main_1.setContentModal)({ title: "Success", content: react_1.default.createElement(react_1.default.Fragment, null, response.message) }));
        }
        else
            dispatch((0, main_1.setContentModal)({ title: constants_1.REQUEST_ERROR_TITLE, content: react_1.default.createElement(react_1.default.Fragment, null, response.message) }));
    };
    const _setCredentials = (value) => {
        setCredentials(Object.assign(Object.assign({}, credentials), value));
    };
    const _onSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        const { password } = credentials;
        showLoader();
        const response = yield (0, update_password_1.update_password)({
            forgot_password_id,
            new_password: credentials.password,
        });
        handleResponse(response);
    });
    return (react_1.default.createElement("div", { className: "flex flex-col gap-y-4 h-full justify-center w-full lg:w-[700px] py-4 lg:py-0 px-4 lg:px-20" },
        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Reset your password", size: "3xlarge", textColor: "text-black", bold: true }),
        react_1.default.createElement(doshx_controls_web_1.LabelControl, { label: "Create a new password for your account.", textColor: "text-black", size: "small" }),
        react_1.default.createElement("div", { className: "w-full flex flex-col gap-y-4" },
            react_1.default.createElement("div", null,
                react_1.default.createElement(PasswordInputControl_1.PasswordInputControl, { label: "Enter New Password", value: credentials.password, errorText: errors.password, borderColor: "border-borders", onChange: (password) => {
                        _setCredentials({ password });
                    } }),
                ENFORCE_PASSWORD_STRENGTH && react_1.default.createElement("p", { className: "mt-1 text-xs text-gray-500" }, PASSWORD_REQUIREMENTS)),
            react_1.default.createElement(PasswordInputControl_1.PasswordInputControl, { label: "Confirm New Password", value: credentials.confirmPassword, errorText: errors.confirmPassword, borderColor: "border-borders", onChange: (confirmPassword) => {
                    _setCredentials({ confirmPassword });
                } }),
            react_1.default.createElement("div", null,
                react_1.default.createElement(doshx_controls_web_1.ButtonControl, { label: "Submit", loading: isLoading, enabled: isValid, backgroundColor: "bg-primary", onClick: _onSubmit }))),
        react_1.default.createElement("div", { className: "flex flex-row justify-between items-center" },
            react_1.default.createElement(doshx_controls_web_1.LinkButtonControl, { textColor: "text-blue-500", iconColor: "text-blue-500", size: "medium", icon: pro_solid_svg_icons_1.faChevronLeft, label: "Back to sign in", iconSide: "left", onClick: () => {
                    navigate(`${routes_1.WELCOME_ROUTE}${routes_1.LOG_IN_ROUTE}`);
                } }))));
};
exports.ResetPasswordPage = ResetPasswordPage;
